var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportsSplashImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "258px",
    height: "203px",
    viewBox: "0 0 258 203",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "1.11022302e-14%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2A8E",
    offset: "1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E56DB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-designs-current",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TP-Comp-Reports-L2-1-NoReports",
    transform: "translate(-800.000000, -369.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15-Copy",
    transform: "translate(754.000000, 326.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IMG-Local-Reports",
    transform: "translate(46.000000, 43.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-28",
    fill: "#3C2A8E",
    transform: "translate(44.500000, 174.000000) rotate(-270.000000) translate(-44.500000, -174.000000) ",
    x: 15.5,
    y: 129.5,
    width: 58,
    height: 89
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-29",
    fill: "#E2E3E6",
    transform: "translate(219.000000, 46.977273) rotate(-270.000000) translate(-219.000000, -46.977273) ",
    x: 172.022727,
    y: 7.97727273,
    width: 93.9545455,
    height: 78
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-30",
    fill: "#F5F5F7",
    opacity: 0.962890625,
    transform: "translate(125.000000, 105.000000) rotate(-270.000000) translate(-125.000000, -105.000000) ",
    x: 41,
    y: -8,
    width: 168,
    height: 226
  }), /*#__PURE__*/React.createElement("g", {
    id: "Asset-23",
    transform: "translate(75.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#202020",
    strokeWidth: 2.63,
    points: "0 0 81.15 0 104 23.68 104 128 0 128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.21,96.46 C34.536888,96.46 20.21,82.133112 20.21,64.46 C20.21,46.786888 34.536888,32.46 52.21,32.46 C69.883112,32.46 84.21,46.786888 84.21,64.46 C84.21,72.9469277 80.8385811,81.0862529 74.837417,87.087417 C68.8362529,93.0885811 60.6969277,96.46 52.21,96.46 Z M52.21,35.4599566 C40.476066,35.439769 29.886278,42.4925509 25.3818707,53.3274912 C20.8774634,64.1624315 23.3462234,76.6440406 31.6362181,84.948353 C39.9262127,93.2526654 52.4035431,95.7429603 63.2462401,91.2572568 C74.0889372,86.7715532 81.16,76.1939514 81.16,64.46 C81.1379808,48.4788658 68.1911256,35.5275385 52.21,35.5 L52.21,35.4599566 Z",
    id: "Shape",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3C2A8E",
    fillRule: "nonzero",
    cx: 52.21,
    cy: 64.46,
    r: 6.1
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsSplashImage);
export default __webpack_public_path__ + "static/media/ReportsSplashImage.bb43f841fce35110d4b299f24c1246e3.svg";
export { ForwardRef as ReactComponent };